import { userSubscribe } from '../../modules/userSubscribe';

export const challengesMine = () => {
  userSubscribe();
};
